<template>
  <div class="order-container">
    <!-- 顶部区域 -->
    <div class="top-section">
      <div class="restaurant-name"
        >{{ orderData.restaurantName }}【{{ orderData.tableNumber }}号桌】</div
      >
      <div class="order-date">{{ orderData.createDate }}</div>
      <div class="order-number">{{ orderData.orderId }}</div>
    </div>

    <!-- 分割线 -->
    <van-divider class="divider" />

    <!-- 中部菜品列表 -->
    <div class="middle-section">
      <div v-for="(dish, index) in orderData.dishes" :key="index" class="dish-item">
        <div style="width: 100%">
          <div class="dish-info">
            <span class="dish-name">{{ dish.name }}</span>
            <span class="quantity-tag">数量:{{ dish.quantity }}</span>
            <van-button class="serve-btn" round @click="emit('serveDish', dish.id)">
              出餐
            </van-button>
          </div>
          <van-divider
            v-if="index < orderData.dishes.length - 1"
            class="divider"
            style="width: 100% !important"
          />
        </div>
      </div>
    </div>

    <!-- 分割线 -->
    <van-divider class="divider" />

    <!-- 底部区域 -->
    <div class="bottom-section">
      <div class="status-text">状态：{{ orderData.status }}</div>
      <van-button class="complete-btn" round @click="emit('completeAll')"> 全部完成 </van-button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { OrderDataModel } from '@/model/kitchen';
  import { ref, defineProps, defineEmits } from 'vue';

  // 定义Props
  const props = defineProps({
    orderData: {
      type: Object as () => OrderDataModel,
      required: true,
    },
  });

  // 定义Emits
  const emit = defineEmits(['serveDish', 'completeAll']);
</script>

<style scoped lang="less">
  .order-container {
    background-color: white;
    border-radius: 12px;
    padding: 16px;
    color: black;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: 300px;
    width: 25%;

    .divider {
      margin: 12px 0;
      background-color: #f2f2f7;
      flex-shrink: 0;
    }

    .top-section {
      text-align: left;
      .restaurant-name {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 8px;
        color: black;
      }

      .order-date {
        font-size: 13px;
        color: #706d71;
        margin-bottom: 4px;
      }

      .order-number {
        font-size: 13px;
        color: black;
      }
    }

    .middle-section {
      flex-grow: 1;
      overflow-y: auto;
      .dish-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;

        .dish-info {
          display: flex;
          align-items: center;
          gap: 10px;
          width: 100%;

          .dish-name {
            font-weight: bold;
            color: black;
            flex-grow: 1;
            text-align: left;
          }

          .quantity-tag {
            background-color: #f2f2f7;
            color: #ff453a;
            border-radius: 12px;
            padding: 2px 8px;
            font-size: 12px;
          }
        }

        .serve-btn {
          background-color: #dc750e;
          color: white;
          font-weight: bold;
          border: none;
          min-width: 70px;
          height: 30px;
        }
      }
    }

    .bottom-section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 8px;
      flex-shrink: 0;
      font-weight: bold;

      .status-text {
        font-size: 14px;
      }

      .complete-btn {
        background-color: #dc750e;
        color: white;
        font-weight: bold;
        border: none;
        min-width: 100px;
        height: 36px;
      }
    }
  }
</style>
